import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { useAtomValue } from 'jotai';
import { esimFiltersAtom } from 'src/atoms/filters/esim-products';
import { fetchESims } from '../api/eSimApi';
import { eSimProductsQueries } from '../../utils/esimProductsQueries';

export const useESimProducts = () => {
  const filters = useAtomValue(esimFiltersAtom);

  const { searchText } = filters;

  const queryResult = useSuspenseQuery({
    queryKey: eSimProductsQueries.list({ searchText }),
    queryFn: async ({ signal }) => {
      const result = await setMinimalPromiseTime(fetchESims({ searchEid: searchText }, signal));

      return result;
    },
  });

  return { queryResult };
};
